import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthService).getToken();

  // Skip the public (pre-auth) endpoints, but logout is authenticated and still needs the token.
  const isPublicAuth = req.url.includes('auth/') && !req.url.includes('auth/logout');

  if (token && !isPublicAuth) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req);
};
